/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Feat_3_DescInputs */

const en_nfp_feat_3_desc = /** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically deliver digital study guides, sermon audio, or exclusive video content to your members the moment they support your cause.`)
};

const es_nfp_feat_3_desc = /** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega automáticamente guías de estudio, audio de sermones o contenido exclusivo a tus miembros.`)
};

const fr_nfp_feat_3_desc = /** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délivrez automatiquement des guides d'étude numériques, des audios de sermons ou du contenu vidéo exclusif à vos membres dès qu'ils soutiennent votre cause.`)
};

const de_nfp_feat_3_desc = /** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle deinen Mitgliedern automatisch digitale Lernhilfen oder exklusive Videoinhalte zur Verfügung.`)
};

const id_nfp_feat_3_desc = /** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikan panduan studi digital, audio khotbah, atau konten video eksklusif secara otomatis kepada anggota Anda saat mereka mendukung tujuan Anda.`)
};

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const ja_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const zh_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const ar_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const it_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const ru_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const pt_nfp_feat_3_desc = en_nfp_feat_3_desc;

/** @type {(inputs: Nfp_Feat_3_DescInputs) => LocalizedString} */
const ko_nfp_feat_3_desc = en_nfp_feat_3_desc;

/**
* | output |
* | --- |
* | "Automatically deliver digital study guides, sermon audio, or exclusive video content to your members the moment they support your cause." |
*
* @param {Nfp_Feat_3_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_feat_3_desc = /** @type {((inputs?: Nfp_Feat_3_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Feat_3_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_feat_3_desc(inputs)
	if (locale === "es") return es_nfp_feat_3_desc(inputs)
	if (locale === "fr") return fr_nfp_feat_3_desc(inputs)
	if (locale === "de") return de_nfp_feat_3_desc(inputs)
	if (locale === "ja") return ja_nfp_feat_3_desc(inputs)
	if (locale === "zh") return zh_nfp_feat_3_desc(inputs)
	if (locale === "ar") return ar_nfp_feat_3_desc(inputs)
	if (locale === "id") return id_nfp_feat_3_desc(inputs)
	if (locale === "it") return it_nfp_feat_3_desc(inputs)
	if (locale === "ru") return ru_nfp_feat_3_desc(inputs)
	if (locale === "pt") return pt_nfp_feat_3_desc(inputs)
	return ko_nfp_feat_3_desc(inputs)
});